<template>
  <b-modal
      id="all-job-codes"
      ref="all-job-codes"
      size="lg-size"
      centered
      hide-footer
      hide-header
      @hide="close"
  >
    <div class="white-card">
      <div class="modal-head white-card-header">
        <div class="d-flex flex-row align-items-center">
          <div class="title-wrap">
            <label class="title-label">{{label.get('job_codes')}}</label>
            <!--<i class="atto info-icon"></i>-->
          </div>
          <form
              class="search-bar"
              action="javascript:void(0);"
          >
            <button
                type="submit"
                class="search-loop"
            >
              <i class="atto atto-search-loop" />
            </button>
            <input
                v-model="search"
                type="search"
                :placeholder="label.get('search')+'...'"
            >
          </form>
        </div>
        <button @click="close">
          <i class="atto atto-close-btn"/>
        </button>
      </div>
      <div class="d-flex flex-column">
        <div class="job-code-header align-items-center d-flex flex-row">
          <label class="job-code">{{label.get('job_code')}}</label>
          <label class="hours"></label>
          <label class="fee"></label>
          <label class="cost">{{label.get('hours')}}</label>
<!--          <label class="hours">Hours</label>
          <label class="fee">Fee</label>
          <label class="cost">Cost</label>-->
        </div>
        <div class="job-codes-body d-flex flex-column hasScroll">
          <perfect-scrollbar ref="all-job-codes-ps">
            <div class="d-flex flex-row align-items-center" v-for="(item, idx) in filteredJobCodes" :key="idx">
              <span class="job-code">{{item.name}}</span>
              <span class="hours"></span>
              <span class="fee"></span>
              <span class="cost">{{item.amount}}</span>
            </div>
            <div class="d-flex align-items-center" v-if="filteredJobCodes.length === 0">
              <span class="no-results">{{label.get('no_results_found')}}</span>
            </div>
          </perfect-scrollbar>
        </div>
      </div>
    </div>
  </b-modal>
</template>


<script>

  export default {
    name: "AllJobCodesComponent",
    props: {
      jobCodes: {
        type: Array,
        default: []
      }
    },
    data(){
      return{
        search: ''
      }
    },
    computed: {
      filteredJobCodes() {
        return this.jobCodes.filter((item) => {
          return item.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
        });
      },
    },
    mounted() {
      document.body.appendChild(this.$el);
      this.$refs['all-job-codes'].show();
      /*setTimeout(() => {
        const perfectScrollbar = this.$refs['all-job-codes-ps'];
        perfectScrollbar.$el.scrolTo = 0;
      }, 100)*/

    },
    methods: {
      close() {
        this.$root.$emit('hideAllJobCodes');
      }
    }
  }
</script>

<style lang="scss" scoped>
  .modal {
    /* .modal-lg-size{
      width: 820px !important;
    }*/

    .white-card {
      box-shadow: none;
      height: 100%;
      border: none;
      margin: 0;
      overflow: hidden;
      max-height: calc(100vh - 60px);

      .white-card-header {
        border-bottom: none;
      }

      .job-code-header {
        height: 35px;
        background-color: #FAFAFA;
        padding: 12px 20px;
        align-items: center;
        border-bottom: none;

        label {
          color: #666666;
          margin: 0;
          letter-spacing: 0.5px;
          font: 500 0.625rem/0.6875rem $roboto-font;
          text-transform: uppercase;
          padding-right: 14px;
          text-align: left;

          &.job-code {
            width: 370px;
          }

          &.hours {
            width: 140px;
          }

          &.fee {
            width: 130px;
          }

          &.cost {
            width: 125px;
            padding-right: 0;
          }
        }
      }

      .job-codes-body {
        padding: 0 !important;

        .flex-row {
          border-top: 1px solid #efefef;
          padding: 5px 10px 6px 20px;
          height: 35px;

          span {
            color: $atto-font-color;
            padding-right: 14px;
            font: 400 0.8125rem/0.9375rem $roboto-font;
            text-align: left;

            &.job-code {
              width: 370px;
              font: 400 0.875rem/1.5rem $roboto-font;
            }

            &.hours {
              width: 140px;
            }

            &.fee {
              width: 130px;
            }

            &.cost {
              width: 125px;
              padding-right: 0;
            }
          }
        }
        .no-results{
          font: 400 1rem/1.5rem $roboto-font;
          color: #999999;
          padding: 30px;
          width: 100%;
          text-align: center;
        }
        .ps {
          padding: 0 !important;
        }

        .ps {
          max-height: calc(100vh - 150px);
          overflow: hidden !important;

          &.ps--active-y {
            overflow: hidden !important;
          }
        }
      }

      .modal-head {
        height: 52px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 14px 20px;

        .search-bar {
          border-radius: 19px;
          border: 1px solid #E3E3E3;
          height: 32px;
          width: 202px;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          padding: 0 14px;
          margin-left: 32px;

          button.search-loop {
            padding: 0 10px 0 0;
            margin: 0;
          }

          i.atto {
            font-size: 12px;
          }

          input[type="search"] {
            border: none;
            width: auto;
            max-width: 140px;
            height: 25px;
            font: 400 0.75rem/1.5rem $roboto-font;
            color: $atto-font-color;
            margin: 0;
            padding: 0;


            &::-webkit-input-placeholder,
            &::-moz-placeholder,
            &:-ms-input-placeholder,
            &:-moz-placeholder {
              color: $atto-font-color !important;
              opacity: 1;
            }
          }
        }

        i.atto-close-btn {
          font-size: 14px;
          color: $grey-nuance-darker;
        }
      }
    }
  }

</style>
